const TagBarData3D=[{
    title: "Photos",
  pic: "bi bi-image tw-left-0",
  className: "type-class",
  className1: "type",page:'search'
},
{
  title: "PSD",
  pic: "bi bi-filetype-psd",
  className: "type-class",
  className1: "type",page:'search'
},
{
  title: "All images",
  pic: "bx bxs-shapes",
  className: "type-class",
  className1: "type",page:'search'
}]
export default TagBarData3D